import React from "react";
import { styled } from '@mui/material/styles'; 
import backgroundImageDesktop from "../../assets/icons/AboutUsBgImage.png";
import backgroundImageMobile from "../../assets/icons/AboutUs_Mobile_BgImage.png";

const AboutUsContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start; 
  background: url(${backgroundImageDesktop}) no-repeat center center/cover;
  position: relative;
  height: 90vh; 

  @media (max-width: 768px) {
    background: url(${backgroundImageMobile}) no-repeat center center/cover;
    background-size: cover;
    min-height: 40vh;
    height: auto;  
    }
`;


const Content = styled('div')`
  position: relative;
  z-index: 1;
  text-align: left;  
  color: #414042; 
  font-size: 4.875rem; /*78px */
  font-family: Montserrat;
  font-weight: 600;
  padding-left: 60px;  
  @media (max-width: 768px) {
    padding-left: 20px;  
    font-size: 2rem;
  }
  @media (max-width: 375px) {
    font-size: 1.250rem; /*20px */
  }

`;

const MainSection = () => {
  return (
    <AboutUsContainer>
      <Content>About Us</Content>
    </AboutUsContainer>
  );
};

export default MainSection;
